import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import AppRenderer from "../../js/app_renderer";
import BookData from "../../js/book_data";
import { TOOLS } from "./tools";
import DEFINE from '../painter/define';
import PainterProxy from '../painter/proxy';
import { store } from "../../store";
import { VIEW_TYPE } from "../view_type";
import SystemData from "../system_data";

export default class LessonTool {

    constructor() {

    }

    getToolFunction() {
        return [
            {
                //選號器
                key: "lottery",
                event: () => {
                    if (store.nowView == VIEW_TYPE.WEB || SystemData.Instance.getPlatform() == 'darwin'
                        || store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
                        AppRenderer.Instance.openFile("https://digitalmaster.knsh.com.tw/all/selector/index.html");
                    } else {
                        AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "CallNumber/callNumber.exe");
                    }
                }
            },
            {
                key: "white_board",
                event: this.openWhiteBoard()
            },
            {
                //五線譜鍵盤
                key: "staff_keyboard",
                event: () => {
                    AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "五線譜鍵盤/五線譜鍵盤.exe");
                }
            },
            {
                //小鍵盤
                key: "keyboard",
                event: () => {
                    AppRenderer.Instance.openFile(BookData.Instance.getItemPath() + "小鍵盤/keyboard/key/key.exe");
                }
            },
            {
                key: TOOLS.GRAPHIC_BOARD.TOOL,
                event: this.usePaintBoard()
            },
            {
                key: "openGraphicBoard",
                event: this.openGraphicBoard()
            },
            {
                key: "setGraphicBoard",
                event: this.setGraphicBoard()
            }
        ]
    }

    openWhiteBoard() {
        Debugger.Instance.log("white_board", "lesson_tool");
        const whiteBoard = EventBus.getInstance().getAppRefs().whiteBoard;

        return () => {
            whiteBoard.openBoard();
        }
    }

    usePaintBoard() {
        Debugger.Instance.log("paint_board", "lesson_tool");
        const proxy = PainterProxy.getInstance();
        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(DEFINE.TOOLS.GRAPHIC_BOARD);
        }
    }

    openGraphicBoard() {
        const graphicBoard = EventBus.getInstance().getAppRefs().graphicBoard;
        return (data) => {
            console.log(`title: ${data.title} id: ${data.id}`);
            graphicBoard.openBoard();
            graphicBoard.set(data.title, data.id, data.board);
        }
    }
    setGraphicBoard() {
        return (title) => {

        }
    }
}